import type { Page } from '@/domain/model/Page';
import type { Mantenedora, UpsertMantenedoraCommand } from '@/domain/model/Mantenedora';
import type { MantenedoraGateway, ListMantenedorasParams } from '@/application/port/out/MantenedoraGateway';
import type {
  ListMantenedorasUseCase, GetMantenedoraUseCase, CreateMantenedoraUseCase,
  UpdateMantenedoraUseCase, DeactivateMantenedoraUseCase,
} from '@/application/port/in/MantenedoraUseCase';

export class ListMantenedoras implements ListMantenedorasUseCase {
  constructor(private readonly g: MantenedoraGateway) {}
  execute(params: ListMantenedorasParams): Promise<Page<Mantenedora>> { return this.g.list(params); }
}
export class GetMantenedora implements GetMantenedoraUseCase {
  constructor(private readonly g: MantenedoraGateway) {}
  execute(id: string): Promise<Mantenedora> { return this.g.get(id); }
}
export class CreateMantenedora implements CreateMantenedoraUseCase {
  constructor(private readonly g: MantenedoraGateway) {}
  execute(cmd: UpsertMantenedoraCommand): Promise<Mantenedora> { return this.g.create(cmd); }
}
export class UpdateMantenedora implements UpdateMantenedoraUseCase {
  constructor(private readonly g: MantenedoraGateway) {}
  execute(id: string, cmd: UpsertMantenedoraCommand): Promise<Mantenedora> { return this.g.update(id, cmd); }
}
export class DeactivateMantenedora implements DeactivateMantenedoraUseCase {
  constructor(private readonly g: MantenedoraGateway) {}
  execute(id: string): Promise<Mantenedora> { return this.g.deactivate(id); }
}
